<footer
  class="app-status-footer bg-primary text-white border-t border-white/10 shadow-[0_-2px_8px_rgba(0,0,0,0.12)]"
  aria-label="Application status">
  <div class="app-status-footer__inner">
    <div class="app-status-footer__segment app-status-footer__segment--motto" [attr.title]="motto">
      {{ motto }}
    </div>
    <div class="app-status-footer__right">
      <div class="app-status-footer__segment">
        <span class="app-status-footer__label">User :</span>
        <span class="app-status-footer__value">{{ username }}</span>
      </div>
      <div class="app-status-footer__segment">
        <span class="app-status-footer__label">Location :</span>
        <span class="app-status-footer__value">{{ locationLabel }}</span>
      </div>
      <div class="app-status-footer__segment">
        <span class="app-status-footer__label">Idle Time :</span>
        <span class="app-status-footer__value">{{ idleSeconds }}</span>
      </div>
      <div class="app-status-footer__segment">
        <span class="app-status-footer__label">Version :</span>
        <span class="app-status-footer__value">{{ appVersion }}</span>
      </div>
      <div class="app-status-footer__segment app-status-footer__segment--batch">
        <span class="app-status-footer__label">Charge Batch:</span>
        <span class="app-status-footer__value">{{ chargeBatch }}</span>
      </div>
      <div class="app-status-footer__segment app-status-footer__segment--batch" [class.app-status-footer__segment--last]="!isEmergencyLogin">
        <span class="app-status-footer__label">Payment Batch:</span>
        <span class="app-status-footer__value">{{ paymentBatch }}</span>
      </div>
      <div *ngIf="isEmergencyLogin" class="app-status-footer__segment app-status-footer__segment--emergency app-status-footer__segment--last">
        Emergency Login
      </div>
    </div>
  </div>
</footer>
